import React, { Component } from "react";
import { HashLink as Link } from "react-router-hash-link-offset";
import Media from "react-media";
import styled from "styled-components";

import logo from "../library/images/Tripwire-Logo.png";
import backgroundImage from "../library/images/TWI_Background_Bottom.jpg";

export default class NavBar extends Component {
  render() {
    return (
      <Media query="(max-width: 1200px)">
        {(matches) =>
          matches ? (
            <NavWrapperMobile>
              <Link to="/">
                <img src={logo} alt="TripWire Company Logo" />
              </Link>
              <div className="links">
                <div className="menu-item">
                  <Link to="/news">
                    <h3>NEWS</h3>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/games">
                    <h3>GAMES</h3>
                  </Link>
                </div>
                <div className="menu-item">
                  <a href="https://forums.tripwireinteractive.com/index.php?communitynews/" target="_blank" rel="noopener noreferrer">
                    <h3>COMMUNITY</h3>
                  </a>
                </div>
                <div className="menu-item">
                  <Link to="/publishing">
                    <h3>PUBLISHING</h3>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/careers">
                    <h3>CAREERS</h3>
                  </Link>
                </div>
              </div>
            </NavWrapperMobile>
          ) : (
            <NavWrapper>
              <Link to="/#top" scrollOffset={-116}>
                <img src={logo} alt="TripWire Company Logo" />
              </Link>
              <div className="links">
                <div className="menu-item">
                  <Link to="/news/#top" scrollOffset={-116}>
                    <h3>NEWS</h3>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/games/#top" scrollOffset={-116}>
                    <h3>GAMES</h3>
                  </Link>
                </div>
                <div className="menu-item">
                  <a href="https://forums.tripwireinteractive.com/index.php?communitynews/" target="_blank" rel="noopener noreferrer">
                    <h3>COMMUNITY</h3>
                  </a>
                </div>
                <div className="menu-item">
                  <Link to="/publishing/#top" scrollOffset={-116}>
                    <h3>PUBLISHING</h3>
                  </Link>
                </div>
                <div className="menu-item">
                  <Link to="/careers/#top" scrollOffset={-116}>
                    <h3>CAREERS</h3>
                  </Link>
                </div>
              </div>
            </NavWrapper>
          )
        }
      </Media>
    );
  }
}

const NavWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  background-image: url(${backgroundImage});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid;
  border-width: 2px 0;
  border-color: #fde704;
  padding: 20px 20px;
  margin: auto;
  text-shadow: 1px 1px #000000;

  .links {
    width: 98vw !important;
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: white;
  }

  .menu-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    padding: 15px 0;
    margin: 2px 5px;
  }

  h3 {
    text-shadow: none !important;
  }

  img {
    height: 70px;
  }

  a {
    color: white;
  }

  a:hover {
    text-decoration: underline;
  }
`;

const NavWrapperMobile = styled.div`
  background-image: url(${backgroundImage});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid;
  border-width: 2px 0;
  border-color: #fde704;
  padding: 20px 10px;
  margin: auto;
  text-shadow: 1px 1px #000000;

  .links {
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    color: white;
    margin: 10px 0;
  }

  .menu-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    padding: 15px 0;
    margin: 2px 5px;
  }

  img {
    height: 70px;
  }

  h3 {
    font-size: 16px;
    text-shadow: none !important;
  }

  a {
    color: white;
  }

  a:hover {
    text-decoration: underline;
  }

  @media (max-width: 750px) {
    .links {
      flex-direction: column;
      margin: 20px 0 15px 0;
    }

    .menu-item {
      width: 100%;
      margin: 5px;
      padding: 20px 0;

      h3 {
        font-size: 20px;
        letter-spacing: 4px;
      }
    }

    img {
      height: 65px;
      padding-bottom: 10px;
      border-bottom: solid;
      border-width: 2px;
      border-color: #fde704;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/NavBar.js